import React, { FunctionComponent } from 'react';

import AuthProvider from './services/auth/auth-provider';
import { GraphQLProvider } from './services/graphql/graphql-provider';
import ScalesExercise from './pages/scales-exercise';

import './styles/main.css';

interface AppProps {}

const App: FunctionComponent<AppProps> = ({}) => {
  return (
    <AuthProvider>
    <GraphQLProvider>
        <WrappedApp />
    </GraphQLProvider>
    </AuthProvider>
  );
}

const WrappedApp: FunctionComponent = () => {
  return <ScalesExercise />
}

export default App;
